import { useEffect, useRef, useState } from 'react';
import {
  Avatar,
  Badge,
  Box,
  Button,
  Chip,
  Container,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextField,
  Typography,
  Paper,
  IconButton,
  InputAdornment,
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { listUserIDAll, updateUserID } from '../../../services/apiUsers';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { getCookie, numberFormat, numberFormatText, removeLocalStorage, setLocalStorage } from '../../../utils/helper';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import EventNoteRoundedIcon from '@mui/icons-material/EventNoteRounded';
import VpnKeyRoundedIcon from '@mui/icons-material/VpnKeyRounded';
import NetworkCellIcon from '@mui/icons-material/NetworkCell';
import ImageIcon from '@mui/icons-material/Image';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SecurityIcon from '@mui/icons-material/Security';
import PublicIcon from '@mui/icons-material/Public';

import styles from './admin.module.scss';
import classNames from 'classnames/bind';
import images from '../../../assets/images';
import { totalPriceSim } from '../../../services/listSim';
import { API_URL_SIMSO } from '../../../config/config';

const cx = classNames.bind(styles);
const names = ['Viettel', 'Mobifone', 'Vinaphone', 'Itelecom', 'Vietnamobile', 'Wintel'];

const localTheme = createTheme({
  palette: {
    primary: { main: '#2563eb' },
    secondary: { main: '#f59e0b' },
    error: { main: '#ef4444' },
    background: { default: '#f8fafc' },
  },
  typography: {
    fontFamily: 'UTM-Avo, sans-serif',
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          padding: '8px 20px',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
        },
      },
    },
  },
});

function DashboardAdmin() {
  const currentDate = new Date();
  const futureDate = new Date(currentDate.getTime() + 3 * 24 * 60 * 60 * 1000).getTime();

  const inputFile = useRef(null);
  const inputFileLogo = useRef(null);
  const hostname = window.location.hostname;
  const [resultAdmin, setResultAdmin] = useState({});
  const [resultAdminID, setResultAdminID] = useState({});
  const [resultPassWord, setResultPassWord] = useState({ pass_old: '', pass_new: '' });
  const [isPassWord, setIsPassWord] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingEdit, setLoadingEdit] = useState(true);
  const [totalPriceAll, setTotalPriceAll] = useState({});
  const [imagesLogoLoading, setImagesLogoLoading] = useState({});
  const [imagesLogo, setImagesLogo] = useState({});

  useEffect(() => {
    fetchApiAdmin();
    totalPriceSimSo();
  }, []);

  const fetchApiAdmin = async () => {
    const getToken = getCookie('token');

    if (getToken) {
      setResultAdmin(getToken);
      setResultAdminID({ ...getToken });
    } else {
      const resultAPISIM = await listUserIDAll(hostname);
      if (resultAPISIM?.length > 0) {
        setResultAdmin(resultAPISIM[0]);
        setResultAdminID({ ...resultAPISIM[0] });
      }
    }
  };

  const totalPriceSimSo = async () => {
    const resultAPISIM = await totalPriceSim(hostname);
    setTotalPriceAll(resultAPISIM[0]);
  };

  const handleChangValueAdmin = (jsonVL) => {
    setResultAdminID({ ...resultAdminID, ...jsonVL });
  };

  const handelUpdateAdmin = async () => {
    setLoading(true);
    const { hanweb, ...restAdmin } = resultAdminID;
    console.log(restAdmin);
    const body = { idUser: resultAdmin.id, data: restAdmin };
    const resultAPISIM = await updateUserID(body);
    if (resultAPISIM?.message === 'Ok') {
      const updatedData = await listUserIDAll(hostname);
      removeLocalStorage('token');
      setLocalStorage('token', { ...updatedData[0], exp: futureDate });
      setResultAdmin({ ...updatedData[0], exp: futureDate });
      setLoading(false);
      setLoadingEdit(true);
      setIsPassWord(false);
    } else {
      setLoading(false);
    }
  };

  const onFilechange = (e) => {
    let file = e.target.files[0];
    if (file && file.size <= 1048576) {
      setImagesLogoLoading({ image: file, url: URL.createObjectURL(file) });
    }
  };

  const onFilechangeLogo = (e) => {
    let file = e.target.files[0];
    if (file && file.size <= 1048576) {
      setImagesLogo({ image: file, url: URL.createObjectURL(file) });
    }
  };

  return (
    <ThemeProvider theme={localTheme}>
      <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', py: 6 }}>
        <Container maxWidth="md">
          <Grid container spacing={3}>
            {/* Header Navigation */}
            {!loadingEdit && (
              <Grid item xs={12}>
                <Button
                  startIcon={<ArrowBackIcon />}
                  onClick={() => {
                    setLoadingEdit(true);
                    setIsPassWord(false);
                  }}
                  sx={{ color: 'text.secondary', '&:hover': { bgcolor: 'rgba(0,0,0,0.04)' } }}
                >
                  Trở về trang quản trị
                </Button>
              </Grid>
            )}

            {/* --- VIEW CHẾ ĐỘ HIỂN THỊ --- */}
            {loadingEdit && (
              <>
                <Grid item xs={12}>
                  <Paper elevation={0} sx={{ borderRadius: 6, overflow: 'hidden', border: '1px solid #e2e8f0' }}>
                    {/* Cover Profile */}
                    <Box
                      sx={{
                        p: 4,
                        background: `linear-gradient(135deg, ${resultAdmin?.background?.split(',')[0] || '#2563eb'} 0%, #7c3aed 100%)`,
                        color: '#fff',
                        position: 'relative',
                      }}
                    >
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} alignItems="center">
                        <Badge
                          overlap="circular"
                          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                          badgeContent={
                            <Box
                              sx={{
                                bgcolor: '#10b981',
                                color: 'white',
                                borderRadius: '50%',
                                p: 0.5,
                                border: '2px solid white',
                                display: 'flex',
                              }}
                            >
                              <CheckCircleIcon sx={{ fontSize: 16 }} />
                            </Box>
                          }
                        >
                          <Avatar
                            src={images.logokhoso}
                            sx={{ width: 100, height: 100, border: '4px solid rgba(255,255,255,0.3)', boxShadow: 3 }}
                          >
                            {resultAdmin?.TITLE_HEADER?.slice(0, 1)}
                          </Avatar>
                        </Badge>
                        <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                          <Typography variant="h4" sx={{ fontWeight: 800, letterSpacing: '-0.5px' }}>
                            {resultAdmin?.TITLE_HEADER || 'Admin Dashboard'}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              opacity: 0.8,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: { xs: 'center', sm: 'flex-start' },
                              mt: 0.5,
                            }}
                          >
                            <PublicIcon sx={{ fontSize: 16, mr: 0.5 }} /> {hostname}
                          </Typography>
                          <Chip
                            label={`Hạn: ${resultAdmin?.hanweb || 'Vô thời hạn'}`}
                            size="small"
                            sx={{
                              mt: 1.5,
                              bgcolor: 'rgba(255,255,255,0.2)',
                              color: 'white',
                              fontWeight: 600,
                              backdropFilter: 'blur(4px)',
                            }}
                          />
                        </Box>
                      </Stack>
                    </Box>

                    {/* Stats Section */}
                    <Grid container sx={{ bgcolor: '#fff' }}>
                      <Grid item xs={6} sx={{ p: 3, textAlign: 'center', borderRight: '1px solid #f1f5f9' }}>
                        <Typography
                          variant="caption"
                          sx={{ color: 'text.secondary', fontWeight: 700, textTransform: 'uppercase' }}
                        >
                          Tổng giá trị bảng
                        </Typography>
                        <Typography variant="h5" sx={{ color: 'primary.main', fontWeight: 800, mt: 0.5 }}>
                          {numberFormatText(totalPriceAll?.total_price) || '0đ'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sx={{ p: 3, textAlign: 'center' }}>
                        <Typography
                          variant="caption"
                          sx={{ color: 'text.secondary', fontWeight: 700, textTransform: 'uppercase' }}
                        >
                          Tổng số lượng Sim
                        </Typography>
                        <Typography variant="h5" sx={{ color: 'secondary.main', fontWeight: 800, mt: 0.5 }}>
                          {numberFormat(totalPriceAll?.total_records?.toString()) || '0'}
                        </Typography>
                      </Grid>
                    </Grid>

                    {/* Info Section */}
                    <Box sx={{ p: 4, bgcolor: '#fff' }}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
                        <Typography variant="h6" fontWeight={700}>
                          Thông tin liên hệ
                        </Typography>
                        <Button
                          variant="contained"
                          startIcon={<BorderColorIcon size={18} />}
                          onClick={() => setLoadingEdit(false)}
                          sx={{ borderRadius: 2, boxShadow: '0 4px 14px 0 rgba(37,99,235,0.39)' }}
                        >
                          Chỉnh sửa
                        </Button>
                      </Stack>

                      <Grid container spacing={3}>
                        {[
                          {
                            icon: <PhoneInTalkIcon sx={{ color: '#ef4444' }} />,
                            label: 'Hotline',
                            text: resultAdmin?.HOTTLINE_SIM,
                          },
                          {
                            icon: <Avatar src={images.iconZalo} sx={{ width: 20, height: 20 }} />,
                            label: 'Zalo',
                            text: resultAdmin?.HOTTLINE_ZALO,
                          },
                          {
                            icon: <MarkEmailUnreadIcon sx={{ color: '#0ea5e9' }} />,
                            label: 'Email',
                            text: resultAdmin?.GMAIL_NOTIFI,
                          },
                          {
                            icon: <AccountBalanceWalletIcon sx={{ color: '#f59e0b' }} />,
                            label: 'Ngân hàng',
                            text: resultAdmin?.bank,
                          },
                          {
                            icon: <NetworkCellIcon sx={{ color: '#10b981' }} />,
                            label: 'Nhà mạng',
                            text: resultAdmin?.mang_show,
                          },
                          {
                            icon: <EventNoteRoundedIcon sx={{ color: '#64748b' }} />,
                            label: 'Địa chỉ',
                            text: resultAdmin?.ADDRESS,
                          },
                        ].map((item, idx) => (
                          <Grid item xs={12} sm={6} key={idx}>
                            <Paper
                              variant="outlined"
                              sx={{
                                p: 2,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 2,
                                borderColor: '#f1f5f9',
                                bgcolor: '#f8fafc',
                              }}
                            >
                              {item.icon}
                              <Box sx={{ minWidth: 0 }}>
                                <Typography variant="caption" color="text.secondary" display="block">
                                  {item.label}
                                </Typography>
                                <Typography variant="body2" fontWeight={600} noWrap>
                                  {item.text || '---'}
                                </Typography>
                              </Box>
                            </Paper>
                          </Grid>
                        ))}
                      </Grid>

                      <Button
                        fullWidth
                        variant="outlined"
                        color="error"
                        startIcon={<VpnKeyRoundedIcon />}
                        onClick={() => {
                          setIsPassWord(true);
                          setLoadingEdit(false);
                        }}
                        sx={{ mt: 4, borderStyle: 'dashed', borderWidth: 2 }}
                      >
                        Bảo mật & Mật khẩu
                      </Button>
                    </Box>
                  </Paper>
                </Grid>

                {/* Logo & Loading Upload Area */}
                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    {[
                      {
                        title: 'Ảnh Loading',
                        ref: inputFile,
                        change: onFilechange,
                        img: imagesLogoLoading?.url || `${API_URL_SIMSO}/showlogo?name=logoload_${hostname}.jpg`,
                        fallback: images.logoloading,
                      },
                      {
                        title: 'Logo Website',
                        ref: inputFileLogo,
                        change: onFilechangeLogo,
                        img: imagesLogo?.url || `${API_URL_SIMSO}/showlogo?name=logo_${hostname}.jpg`,
                        fallback: images.logokhoso,
                      },
                    ].map((upload, idx) => (
                      <Grid item xs={12} sm={6} key={idx}>
                        <Paper sx={{ p: 3, textAlign: 'center', height: '100%' }}>
                          <Typography variant="subtitle2" fontWeight={700} gutterBottom color="text.secondary">
                            {upload.title}
                          </Typography>
                          <Box
                            onClick={() => upload.ref.current.click()}
                            sx={{
                              mt: 2,
                              p: 3,
                              border: '2px dashed #e2e8f0',
                              borderRadius: 4,
                              cursor: 'pointer',
                              transition: 'all 0.2s',
                              '&:hover': { bgcolor: '#f8fafc', borderColor: 'primary.main' },
                            }}
                          >
                            <input type="file" ref={upload.ref} hidden onChange={upload.change} />
                            <Box sx={{ position: 'relative', display: 'inline-block' }}>
                              <img
                                src={upload.img}
                                style={{ maxHeight: 80, maxWidth: '100%', objectFit: 'contain' }}
                                onError={(e) => (e.target.src = upload.fallback)}
                                alt="preview"
                              />
                              <Box
                                sx={{
                                  position: 'absolute',
                                  bottom: -10,
                                  right: -10,
                                  bgcolor: 'primary.main',
                                  color: 'white',
                                  borderRadius: '50%',
                                  p: 0.5,
                                  display: 'flex',
                                  boxShadow: 2,
                                }}
                              >
                                <CloudUploadIcon sx={{ fontSize: 14 }} />
                              </Box>
                            </Box>
                            <Typography variant="caption" display="block" sx={{ mt: 2, color: 'text.secondary' }}>
                              Nhấp để tải ảnh lên (Tối đa 1MB)
                            </Typography>
                          </Box>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </>
            )}

            {/* --- VIEW CHẾ ĐỘ CHỈNH SỬA --- */}
            {!loadingEdit && !isPassWord && (
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 3, md: 5 }, borderRadius: 6 }}>
                  <Typography variant="h5" fontWeight={800} mb={4}>
                    Cấu hình Website
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="ID URL Trang Tính"
                        value={resultAdminID?.link_gg || ''}
                        onChange={(e) => handleChangValueAdmin({ link_gg: e.target.value })}
                        helperText="Dán mã ID từ Google Sheets của bạn"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Email thông báo"
                        value={resultAdminID?.GMAIL_NOTIFI || ''}
                        onChange={(e) => handleChangValueAdmin({ GMAIL_NOTIFI: e.target.value })}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Zalo liên hệ"
                        value={resultAdminID?.HOTTLINE_ZALO || ''}
                        onChange={(e) => handleChangValueAdmin({ HOTTLINE_ZALO: e.target.value })}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Hotline hiển thị"
                        value={resultAdminID?.HOTTLINE_SIM || ''}
                        onChange={(e) => handleChangValueAdmin({ HOTTLINE_SIM: e.target.value })}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Hotline gọi trực tiếp"
                        value={resultAdminID?.HOTTLINE_SIM_CALL || ''}
                        onChange={(e) => handleChangValueAdmin({ HOTTLINE_SIM_CALL: e.target.value })}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Tiêu đề Header"
                        value={resultAdminID?.TITLE_HEADER || ''}
                        onChange={(e) => handleChangValueAdmin({ TITLE_HEADER: e.target.value })}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label="Thông tin ngân hàng"
                        value={resultAdminID?.bank || ''}
                        onChange={(e) => handleChangValueAdmin({ bank: e.target.value })}
                      />
                      <b>VD mẫu TK Ngân Hàng: NGÂN HÀNG MBBANK,LE MINH DUY,7719999</b>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <InputLabel>Nhà mạng hiển thị</InputLabel>
                        <Select
                          multiple
                          value={resultAdminID?.mang_show?.split(',').filter((i) => i) || []}
                          onChange={(e) => handleChangValueAdmin({ mang_show: e.target.value.toString() })}
                          input={<OutlinedInput label="Nhà mạng hiển thị" />}
                          renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                              {selected.map((value) => (
                                <Chip key={value} label={value} size="small" color="primary" variant="soft" />
                              ))}
                            </Box>
                          )}
                        >
                          {names.map((name) => (
                            <MenuItem key={name} value={name}>
                              {name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="contained"
                        size="large"
                        onClick={handelUpdateAdmin}
                        disabled={loading}
                        sx={{ py: 2, fontSize: '1.1rem', boxShadow: '0 10px 15px -3px rgba(37,99,235,0.4)' }}
                      >
                        {loading ? 'Đang lưu cấu hình...' : 'Cập nhật ngay'}
                      </Button>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            )}

            {/* --- VIEW ĐỔI MẬT KHẨU --- */}
            {!loadingEdit && isPassWord && (
              <Grid item xs={12} md={7} sx={{ mx: 'auto' }}>
                <Paper sx={{ p: 5, borderRadius: 6, textAlign: 'center' }}>
                  <Box sx={{ mb: 3 }}>
                    <SecurityIcon sx={{ fontSize: 60, color: 'error.main', opacity: 0.2 }} />
                    <Typography variant="h5" fontWeight={800} mt={2}>
                      Đổi mật khẩu
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Đảm bảo mật khẩu của bạn có ít nhất 6 ký tự
                    </Typography>
                  </Box>
                  <Stack spacing={3}>
                    <TextField
                      fullWidth
                      type="password"
                      label="Mật khẩu hiện tại"
                      onChange={(e) => setResultPassWord({ ...resultPassWord, pass_old: e.target.value })}
                    />
                    <TextField
                      fullWidth
                      type="password"
                      label="Mật khẩu mới"
                      onChange={(e) => handleChangValueAdmin({ pass_word: e.target.value })}
                    />
                    <TextField
                      fullWidth
                      type="password"
                      label="Xác nhận mật khẩu mới"
                      onChange={(e) => setResultPassWord({ ...resultPassWord, pass_new: e.target.value })}
                    />
                    <Button
                      fullWidth
                      variant="contained"
                      color="error"
                      size="large"
                      onClick={handelUpdateAdmin}
                      sx={{ py: 2 }}
                    >
                      Xác nhận thay đổi
                    </Button>
                  </Stack>
                </Paper>
              </Grid>
            )}
          </Grid>
        </Container>
      </Box>
    </ThemeProvider>
  );
}

export default DashboardAdmin;
